// extracted by mini-css-extract-plugin
export var item = "styles-module--item--311fe";
export var marquee = "styles-module--marquee--e60b0";